import React from 'react';
import styled from 'styled-components';
import Icon from 'components/icon';

const Wrapper = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  flex-direction: column;
  font-size: 15px;
  background-color: #fff5d6;
`;

const BoxMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border: 1px solid #ddd;
  background-color: #fff;
  padding: 60px;
  border-radius: 10px;
  box-shadow: 0 3px 16px rgba(0, 0, 0, 0.1);
  max-width: calc(100% - 32px);
  text-align: center;
  .message {
    font-size: 3em;
    margin-top: 40px;
  }
  p {
    max-width: 520px;
  }
  @media (max-width: 600px) {
    padding: 32px 20px;
    .message {
      font-size: 1.8em;
      margin-top: 24px;
    }
  }
`;

// The signing link itself expired. The server re-sends a fresh link at most once an hour, so the
// copy can't promise one was just sent.
export default () => {
  return (
    <Wrapper>
      <BoxMessage>
        <Icon color="#dc0100" name="fa-duotone fa-link-slash" size={60} />
        <div className="message">This link is no longer valid.</div>
        <p>If you don't see a new link in your inbox, contact the sender.</p>
      </BoxMessage>
    </Wrapper>
  );
};

const DEFAULT_EXPIRED_REASON = 'This document has expired. Contact the sender for a new link.';

// The document is past its expiration date (portal 410 DOCUMENT_EXPIRED). Nothing to retry and
// no new link is coming: the server's `reason` says when it expired and what to do.
export const DocumentExpired = ({ reason }) => (
  <Wrapper>
    <BoxMessage role="alert">
      <Icon color="#dc0100" name="fa-duotone fa-calendar-xmark" size={60} />
      <div className="message">This document has expired.</div>
      <p>{reason || DEFAULT_EXPIRED_REASON}</p>
    </BoxMessage>
  </Wrapper>
);
